import { Outlet } from 'react-router-dom';

import { useAuthStore } from '@/stores/authStore';

import { Sidebar } from './Sidebar';

export function Layout() {
  // Read auth state directly - don't trigger checkAuthStatus
  // (AuthGuard already handles auth state initialization)
  const user = useAuthStore((state) => state.user);
  const logout = useAuthStore((state) => state.logout);

  return (
    <div className="flex min-h-screen bg-slate-100">
      {/* Sidebar */}
      <Sidebar />

      {/* Main content */}
      <div className="flex-1 flex flex-col">
        {/* Header */}
        <header className="bg-white border-b border-slate-200 px-6 py-4">
          <div className="flex items-center justify-between">
            <h1 className="text-lg font-semibold text-slate-900">Yarn Tales Admin</h1>
            <div className="flex items-center gap-4">
              <span className="text-sm text-slate-600">{user?.email}</span>
              <button
                onClick={() => logout()}
                className="text-sm text-slate-600 hover:text-slate-900"
              >
                Sign Out
              </button>
            </div>
          </div>
        </header>

        {/* Page content */}
        <main className="flex-1 p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
